export default "__VITE_ASSET__7263904d__"